var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "site-selector",
      class: { "site-selector--index": _vm.isIndex },
    },
    _vm._l(_vm.data, function (item) {
      return !item.active
        ? _c("a", {
            key: item.lid,
            staticClass: "site-selector__link",
            attrs: { title: item.title, href: _vm.setUrl(item.url, item.lid) },
            domProps: { innerHTML: _vm._s(item.lang) },
          })
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }